<template>
  <v-dialog
    v-model="showModal"
    persistent
    fullscreen
  >
    <div class="content-section">
      <h1 class="header-style">
        Cost Shift
      </h1>
      <br>
      <p class="subheader-style">
        Click <font class="next-text">
          'Next'
        </font> to complete the cost shift.
      </p>
      <v-btn
        fab
        color="#E6E6E6"
        small
        rounded
        elevation="0"
        class="close-button"
        @click="showModal = false"
      >
        <v-icon color="#37474f">
          mdi mdi-close
        </v-icon>
      </v-btn>
      <v-stepper
        v-model="workerCostShift"
        light
        class="my-stepper-style"
        elevation="0"
      >
        <v-stepper-header>
          <v-stepper-step
            :complete="workerCostShift > 1"
            step="1"
            color="#37474F"
          />
          <v-divider />
          <v-stepper-step
            :complete="workerCostShift > 2"
            step="2"
            color="#37474F"
          />
        </v-stepper-header>
      </v-stepper>
      <div>
        <gather-worker-details
          v-if="showWorkDetailsPage"
          :active-check-in-details="activeCheckInDetails"
          @work-details-stored="toSecondStep"
        />
        <review-work-details
          v-if="showWorkReviewPage"
          :active-check-in-details="activeCheckInDetails"
          @checkin-completed="checkInCompleted"
        />
      </div>
    </div>
  </v-dialog>
</template>
<script>
import GatherWorkDetails from '../dialogComponents/CostshiftDialogs/GatherWorkDetails.vue';
import ReviewWorkDetails from '../dialogComponents/CostshiftDialogs/ReviewWorkDetails.vue';
export default {
  name: 'WorkerCostShiftPage',
  components: {
    'gather-worker-details': GatherWorkDetails,
    'review-work-details': ReviewWorkDetails,
  },
  props: {
    activeCheckInDetails: {
        type: Object,
        default: null,
    },
  },
  data: () => ({
    showModal: true,
    workerCostShift: 1,
    showWorkDetailsPage: true,
    showLocationVerificationPage: false,
    showWorkReviewPage: false,
  }),
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  methods: {
    toSecondStep () {
        this.step1SuccessColor = '#00796B';
        this.workerCostShift = 2;
        this.showLocationVerificationPage = true;
        this.showWorkDetailsPage = false;
        this.showWorkReviewPage = true;
      },
      toThirdStep () {
        this.step1SuccessColor = '#00796B';
        this.workerCostShift = 2;
        this.showLocationVerificationPage = false;
        this.showWorkDetailsPage = false;
        this.showWorkReviewPage = true;
      },
      checkInCompleted () {
        this.$router.push({ name: 'Costshift Success' });
      },
  },
};
</script>
